<template>
  <div class="rules">
    <h4 class="headtitle" v-if="this.loginType==1">{{ $t("accountlogin1") }}:</h4>
    <h4 class="headtitle" v-else>{{ $t("accountlogin2") }}:</h4>
    <div class="boxs">
      <div style="position: relative">
        <el-form
          style="
            max-width: 541px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
          "
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlign"
        >
          <el-form-item>
            <img
              style="width: 33px; height: 33px; margin-right: 21px"
              src="@/assets/130472x.png"
              alt=""
            />
            <el-input
              v-model="formLabelAlign.name"
              :placeholder="$t('Account')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <img
              style="width: 33px; height: 33px; margin-right: 21px"
              src="@/assets/63040@2x.png"
              alt=""
            />
            <el-input
              v-model="formLabelAlign.region"
              :placeholder="$t('Password')"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <div class="Forgotpassword" >
            <p>?</p>
            <span @click="forgetPassword" style="cursor: pointer;">{{ $t("Forgotpassword") }}</span>
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              margin-top: 20px;
            "
          >
            <div class="buttoms" @click.stop="login">{{ $t("login") }}</div>
            <div class="register" v-if="this.loginType==1">
              {{ $t("Noaccountyet")
              }}<span @click.stop="register">{{ $t("Registernow") }}</span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "left",
      loginLoading: false,
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
    };
  },
  created(){
    console.log(this.loginType)
  },
  methods: {
    register() {
      this.SETACTIVE(8);
    },
    forgetPassword() {
      this.SETACTIVE(9);
    },
    login() {
      // console.log(this.loginType);
      // return
      if (!this.$test.mobile(this.formLabelAlign.name)) {
        this.$message({
          message: "请输入正确的账号格式",
        });
        return;
      }
      if (this.formLabelAlign.region == "") {
        this.$message({
          message: "请输入密码",
        });
        return;
      }
      if (this.loginLoading) {
        return;
      }
      this.loginLoading = true;
      this.$postHttp("pc/tJudgesInfo/login", {
        phone: this.formLabelAlign.name,
        password: this.formLabelAlign.region,
        type: this.loginType,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.loginLoading = false;
          this.SETUSERINFO(res.userinfo);
          this.SETACTIVES(-1)
          this.$router.push({ path: "/user" });
        } else {
          this.$message({
            message: res.msg,
          });
          this.loginLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.rules {
  text-align: left;
  .headtitle {
    position: relative;
    font-size: 26px;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    font-weight: 500;
    padding-left: 20px;
    margin-left: 5px;
    margin-top: 6px;
    margin-bottom: 25px;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 24px;
      background: #6f73f4;
      border-radius: 2px 2px 2px 2px;
    }
  }
  .boxs {
    .el-form-item__content {
      display: flex;
      align-items: center;
      margin-left: 0 !important;
    }
  }
}

.Forgotpassword {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  p {
    padding: 0;
    margin: 0;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: flex;
    font-size: 12px;
    color: #999999;
    align-items: center;
    justify-content: center;
    border: 1px solid #999999;
    margin-right: 4px;
  }
  span {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    display: block;
    // width: 70px;
  }
}

.buttoms {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 56px;
  background: linear-gradient(262deg, #6a9cff 0%, #5257ff 100%);
  border-radius: 10px 10px 10px 10px;
  font-size: 24px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}

.register {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  span {
    color: #6f73f4;
    cursor: pointer;
  }
}
</style>